// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acc_btn_bus:not(.collapsed){
    background-color: #fff !important;
    box-shadow: inset 0 -1px 0 #fff !important;
  }

  .acc_btn_bus:focus{
    background-color: #fff !important;
    box-shadow: inset 0 -1px 0 #fff !important;
  }

  .for_gray_accordian{
    margin-right: 0px;
    margin-left: 0px;
    background-color: #fff;
  }`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/Driveanalysis_Orion/TopFiveSectionTemplate_Orion.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,0CAA0C;EAC5C;;EAEA;IACE,iCAAiC;IACjC,0CAA0C;EAC5C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;EACxB","sourcesContent":[".acc_btn_bus:not(.collapsed){\n    background-color: #fff !important;\n    box-shadow: inset 0 -1px 0 #fff !important;\n  }\n\n  .acc_btn_bus:focus{\n    background-color: #fff !important;\n    box-shadow: inset 0 -1px 0 #fff !important;\n  }\n\n  .for_gray_accordian{\n    margin-right: 0px;\n    margin-left: 0px;\n    background-color: #fff;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
